module.exports = __webpack_public_path__ + "img/xmasParty14.43a88e78.jpg";